import { Direction, Size } from '@philips-emr/tws-constants';
import { ComponentAPI } from '@philips-emr/tws-core';
import { isEnumValid } from '@philips-emr/tws-utils';

class AvatarAPI extends ComponentAPI {

  setTitle(title: string): void {
    this.setState({ title });
  }

  getTitle(): string {
    return this.state.title;
  }

  setSubtitle(subtitle: string): void {
    this.setState({ subtitle });
  }

  getSubtitle(): string {
    return this.state.subtitle;
  }

  setSubtitlesHiddenOnMobile(subtitleHiddenOnMobile: string): void {
    this.setState({ subtitleHiddenOnMobile });
  }

  isSubtitlesHiddenOnMobile(): boolean {
    return this.state.subtitleHiddenOnMobile;
  }

  setImage(image: string): void {
    this.setState({ image });
  }

  getImage(): string {
    return this.state.image;
  }

  setSize(size: number): void {
    if (!isEnumValid(Size, size)) return;

    this.setState({ size });
  }

  getSize(): number {
    return this.state.size;
  }

  setDirection(direction: Direction): void {
    if (!isEnumValid(Direction, direction)) return;

    this.setState({ direction });
  }

  getDirection(): Direction {
    return this.state.direction;
  }

}

export default AvatarAPI;
